import { type ApolloClient, gql, type NormalizedCacheObject } from '@apollo/client/core';
import type { Query, QueryWillCallRecipientCountArgs } from '../../../generated/api.graphql';

export const WILL_CALL_RECIPIENT_COUNT_QUERY = gql`
  query WillCallRecipientCount($eventId: Int!, $ticketBlueprintId: Int) {
    willCallRecipientCount(eventId: $eventId, ticketBlueprintId: $ticketBlueprintId)
  }
`;

/** How many distinct people a will-call send reaches: one buyer holding several tickets is one email. */
export const fetchWillCallRecipientCount = async (
  client: ApolloClient<NormalizedCacheObject>,
  eventId: number,
  ticketBlueprintId?: number,
): Promise<number> => {
  const { data } = await client.query<Query, QueryWillCallRecipientCountArgs>({
    query: WILL_CALL_RECIPIENT_COUNT_QUERY,
    fetchPolicy: 'network-only',
    variables: { eventId, ticketBlueprintId },
  });

  if (!data) {
    throw new Error('Failed to fetch the will-call recipient count.');
  }

  return data.willCallRecipientCount;
};
